import type { ReactNode } from 'react';

import { CheckmarkIcon } from '@ctct/payflow-ui';

export const PriceEstimatorDialogTier = ({ index, children }: { index: number; children?: ReactNode }) => (
  <tr data-qe-id={`new-selector-tier-row-${index}`}>{children}</tr>
);

export const PriceEstimatorDialogContacts = ({ children }: { children?: ReactNode }) => (
  <td className="price-estimator-contact-col">{children}</td>
);

export const PriceEstimatorDialogPricing = ({ children }: { children?: ReactNode }) => (
  <td className="price-estimator-pricing-col">{children}</td>
);

export const PriceEstimatorDialogCheckboxColumn = ({ isChecked = false }: { isChecked?: boolean }) => (
  <td className="price-estimator-checkbox-col">{isChecked ? <CheckmarkIcon /> : null}</td>
);
